import React from 'react';

import { LDLDebug } from './LDLDebug';

import { TWCPage } from '../../primitives/TWCPage/TWCPage';

export const LDLDebugPage = ({ route }) => {
  const { debugItem } = route.params;

  return (
    <TWCPage
      childIds={['LDL_alertHeadlines_debug_item']}
      firstFocus={'LDL_alertHeadlines_debug_item'}
      pageID={debugItem.pageID}
    >
      <LDLDebugContent />
    </TWCPage>
  );
};

const LDLDebugContent = () => <LDLDebug />;
